import { render } from "./VehicleCreate.vue?vue&type=template&id=926ba2f0"
import script from "./VehicleCreate.vue?vue&type=script&lang=js"
export * from "./VehicleCreate.vue?vue&type=script&lang=js"

import exportComponent from "/home/travelcrm/travel-crm-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__